<template>
    <v-dialog v-model="isOpen" :scrim="false" @click:outside="cancel">
        <v-card v-if="data">
            <v-card-title class="text-h5 bg-grey-lighten-2">
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <div class="d-flex justify-start">
                                <a v-bind:href="data.request_url" target="_blank">
                                    {{ data.request_registry_id }}
                                </a>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <div class="d-flex justify-end text-subtitle-1">
                                Created - {{ data.date_submitted }}
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="4">
                        {{ this.data }}
                    </v-col>
                    <v-col cols="4">
                        <a v-bind:href="this.data.url" target="_blank">View Benching Request</a>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        Plates -
                        {{
                            this.data.plate_registry_ids.length && this.data.plate_registry_ids[0]
                                ? this.data.plate_registry_ids
                                : "None"
                        }}
                    </v-col>
                    <v-col cols="4"> Samples - {{ this.data.samples.length }} </v-col>
                </v-row>
                <v-row>
                    <v-col> </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="darken-1" variant="text" @click="cancel"> Cancel </v-btn>

                <v-btn color="darken-1" variant="text" @click="save"> Save </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ReqDialog",
    props: ["value", "show"],

    computed: {
        data: function () {
            return this.modelValue;
        },
        showDialog: function () {
            console.log("show dialog");
            console.log(this.data);
            if (this.data) {
                console.log("returning true");
                return true;
            }
            return false;
        },
        isOpen: function () {
            return this.show;
        },
    },

    methods: {
        closeEvent: function () {
            console.log("close event called");
        },
        cancel: function () {
            console.log("cancel");
            this.$emit("onSave", false);
            // this.$router.replace({ path: `/requests`}).catch(()=>{});
            // return false;
        },
        save: function () {
            // this.$router.replace({ path: `/requests`}).catch(()=>{});
            console.log("this.data");
            console.log(this.data);
            this.data.status = "123";
            this.$emit("onSave", false);
            this.$emit("update:modelValue", this.data);
            // this.data = null;
        },
    },

    data() {
        return {
            // Control if dialog is visible or not
            // data: null
        };
    },
});
</script>
